<template>
	<v-dialog v-model="dialogValue" max-width="900px" persistent>
		<DialogPersonalizado :titulo="titulo()" icone="mdi-account-tie-outline" @dialogClose="dialogClose">
			<v-row align="center" v-if="loading" justify="center" class="pa-4">
				<v-progress-linear color="primary" indeterminate />
			</v-row>
			<v-row v-if="id">
				<v-col cols="9" sm="10" md="11" class="pt-0 pb-0">
					Chave
					<v-text-field solo placeholder="Chave" v-model="fornecedor.id" disabled hide-details class="mb-3" />
				</v-col>
				<v-col>
					<v-btn text min-width="0" class="pa-0 mt-4" @click="copiarChave()">
						<v-icon color="red"> mdi-content-copy </v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6" class="pt-0 pb-0">
					Razão Social
					<v-text-field
						solo
						placeholder="Razão Social"
						v-model="fornecedor.razaoSocial"
						hide-details
						class="mb-3"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12" md="6" class="pt-0 pb-0">
					Nome Fantasia
					<v-text-field
						solo
						placeholder="Nome Fantasia"
						v-model="fornecedor.nomeFantasia"
						hide-details
						class="mb-3"
					>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="6" class="pt-0 pb-0">
					CPF ou CPNJ
					<v-text-field
						solo
						placeholder="CPF ou CPNJ"
						v-model="fornecedor.cpfCnpj"
						hide-details
						@input="mascaraCpfCnpj = formatarCpfCnpj(fornecedor.cpfCnpj)"
						v-mask="mascaraCpfCnpj"
						class="mb-3"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12" md="6" class="pt-0 pb-0">
					E-mail
					<v-text-field
						solo
						placeholder="E-mail"
						type="email"
						v-model="fornecedor.email"
						hide-details
						class="mb-3"
					>
					</v-text-field>
				</v-col>
			</v-row>
			<v-row v-if="id">
				<v-col cols="6" class="pt-0 pb-0">
					<v-checkbox
						:ripple="false"
						label="Ativo?"
						class="mt-0"
						v-model="fornecedor.ativo"
						color="#cc2128"
						hide-details
					></v-checkbox>
				</v-col>
				<v-col cols="12" xs="12" sm="12" md="6" xl="6" class="pt-0 pb-0">
					<v-btn text color="red" @click="alterarSenha()" class="pa-0"> Alterar senha </v-btn>
				</v-col>
			</v-row>
			<v-row v-if="!id" class="mb-1">
				<v-col cols="12" md="6" class="pt-0 pb-0">
					Senha
					<v-text-field
						solo
						placeholder="senha"
						v-model="fornecedor.senha"
						@click:append="show = !show"
						:type="show ? 'text' : 'password'"
						class="mb-3"
						hide-details
					>
						<template v-slot:append>
							<v-icon color="red" @click="show = !show">
								{{ show ? 'mdi-eye' : 'mdi-eye-off' }}
							</v-icon>
						</template>
					</v-text-field>
				</v-col>
				<v-col cols="12" md="6" class="pt-0 pb-0">
					Confirmar senha
					<v-text-field
						solo
						placeholder="senha"
						v-model.lazy="fornecedor.confirmarSenha"
						@click:append="show2 = !show2"
						:type="show2 ? 'text' : 'password'"
						class="mb-3"
						hide-details
					>
						<template v-slot:append>
							<v-icon color="red" @click="show2 = !show2">
								{{ show2 ? 'mdi-eye' : 'mdi-eye-off' }}
							</v-icon>
						</template>
					</v-text-field>
				</v-col>
			</v-row>
			<v-btn v-if="id && userAdmin" class="red--text mt-4" @click="dialogExcluirOpen()" large width="100%">
				<v-icon>mdi-delete-outline</v-icon> Excluir
			</v-btn>
			<v-btn class="white--text mt-4" @click="salvar()" color="#CC2128" large elevation="9" width="100%">
				Salvar
			</v-btn>
		</DialogPersonalizado>
		<AlterarSenha :abrirDialog="abrir" @dialogClose="closeAlterarSenha" :id="this.id" tipo="fornecedor" />
		<DialogExcluir
			:abrirDialog="excluir"
			:id="this.id"
			@fecharDialog="dialogExcluirClose"
			@fecharTodosDialogs="dialogClose"
		/>
	</v-dialog>
</template>

<script>
import DialogPersonalizado from '../shared/dialogPersonalizado.vue'
import AlterarSenha from '../shared/RedefinirSenha.vue'
import DialogExcluir from './DialogExcluirFornecedor.vue'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	components: {
		DialogPersonalizado,
		AlterarSenha,
		DialogExcluir,
	},
	data() {
		return {
			mascaraCpfCnpj: '',
			show: false,
			show2: false,
			fornecedor: {},
			abrir: false,
			loading: false,
			excluir: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState('usuarios', ['usuario', 'dialog']),
		dialogValue: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.dialogClose()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),
		dialogClose() {
			this.fornecedor = {}
			this.$emit('dialogClose')
		},
		copiarChave() {
			navigator.clipboard
				.writeText(this.fornecedor.id)
				.then(() => {
					this.$store.dispatch('showSuccess', 'Chave copiada com sucesso!')
				})
				.catch(() => {
					this.$store.dispatch('showError', 'Erro ao copiar chave')
				})
		},

		async loadFornecedor() {
			if (this.id) {
				try {
					this.loading = true
					const response = await this.axios.get(`/fornecedor/${this.id}`)
					this.fornecedor = response.data.fornecedor
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.loading = false
				}
			}
		},
		async salvar() {
			if (this.id) {
				this.editar()
			} else {
				this.criar()
			}
		},
		async criar() {
			if (!(this.fornecedor.senha == this.fornecedor.confirmarSenha))
				this.$store.dispatch('showError', 'As senhas não estão iguais')
			else {
				try {
					this.loading = true
					const response = await this.axios.post('/fornecedor', {
						razaoSocial: this.fornecedor.razaoSocial,
						nomeFantasia: this.fornecedor.nomeFantasia,
						email: this.fornecedor.email,
						cpfCnpj: this.fornecedor.cpfCnpj,
						codigo: this.fornecedor.senha,
						senha: this.fornecedor.senha,
					})

					if (response.status == 204) {
						this.$store.dispatch('showSuccess', 'Fornecedor cadastrado com sucesso')
						this.dialogClose()
					}
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.loading = false
				}
			}
		},
		async editar() {
			try {
				this.loading = true
				const response = await this.axios.put(`/fornecedor/${this.id}`, {
					razaoSocial: this.fornecedor.razaoSocial,
					nomeFantasia: this.fornecedor.nomeFantasia,
					email: this.fornecedor.email,
					cpfCnpj: this.fornecedor.cpfCnpj,
					ativo: this.fornecedor.ativo,
				})
				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Fornecedor alterado com sucesso!')
					this.dialogClose()
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		titulo() {
			if (this.id) return 'Editar Fornecedor'
			else return 'Cadastrar Fornecedor'
		},
		alterarSenha() {
			this.abrir = true
		},
		closeAlterarSenha() {
			this.abrir = false
		},
		dialogExcluirOpen() {
			this.excluir = true
		},
		dialogExcluirClose() {
			this.excluir = false
		},
	},
	watch: {
		dialogValue() {
			this.fornecedor = {}
			this.loadFornecedor()
		},
	},
}
</script>
